"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INBOUND_URL = exports.getApiPath = void 0;
const getApiPath = (rootUrl) => {
    return {
        EVENTS: `${rootUrl}/public/events`,
        PUBLIC_TICKETS: `${rootUrl}/public/tickets`,
        PUBLIC_BOOKINGS: `${rootUrl}/v1/bookings`,
        PUBLIC_ACCOUNTS: `${rootUrl}/public/accounts`,
        PUBLIC_GROUPS: `${rootUrl}/public/groups`,
        WEBSITE_PUBLIC_EVENTS: `${rootUrl}/events`,
        WEBSITE_PUBLIC_TICKETS: `${rootUrl}/tickets`,
        WEBSITE_PUBLIC_ACCOUNTS: `${rootUrl}/accounts`,
        WEBSITE_PUBLIC_GROUPS: `${rootUrl}/groups`,
    };
};
exports.getApiPath = getApiPath;
const InboundRootUrl = "https://websites-admin.we-conect.com/api";
exports.INBOUND_URL = {
    VISITOR: `${InboundRootUrl}/visitor`,
    INBOUND: `${InboundRootUrl}/inbound`,
};
